import React from 'react';
import { Switch, Route } from 'react-router-dom';

import EditProduct from './EditProduct';
import NewProduct from './NewProduct';
import ListProducts from './ListProducts';

function ProductsPage() {
  return (
    <Switch>
      <Route exact path="/products" component={ListProducts} />
      <Route path="/products/new" component={NewProduct} />
      <Route path="/products/:id" component={EditProduct} />
    </Switch>
  );
}

export default ProductsPage;
